import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { CollectApiServiceBase } from './collect-api-base.service';
import { ProgressIndicatorService, ProgressConfig } from './progress-indicator.service';
import { plainToClass } from 'class-transformer';

import { FormInstance } from '../models/site-content/form-instance.model';
import { AsyncJob } from '../models/async-job.model';
import { RouteReuseService } from './route-reuse.service';

@Injectable({
    providedIn: 'root'
})
export class FormInstanceAsyncService extends CollectApiServiceBase<AsyncJob> {
    // Constructor.
    constructor(http: HttpClient, progressIndicatorService: ProgressIndicatorService, private routeReuseService: RouteReuseService) {
        super(http, progressIndicatorService, environment.apiUrl, 'formInstanceAsync', AsyncJob)
    }

    public getFormInstanceOpenLogEntries(formInstanceId: number, createdSince: string) {
        const url = `${this.url}/${this.endpoint}/getFormInstanceOpenLogEntries/${formInstanceId}/${createdSince}`;
        return this.http.get<AsyncJob>(url)
            .toPromise()
            .then(response => {
                return response;
            })
            .catch(this.handleError);
    }

    // Added as an experiment, but it's not being used
    public getContentAsync(id: number): Promise<AsyncJob> {
        const url = `${this.url}/${this.endpoint}/getContentAsync/${id}`;

        return this.http.get<AsyncJob>(url)
            .toPromise()
            .then(response => {
                return response;
            })
            .catch(this.handleError);
    }

    // Service methods.
    public updateContentAsync(formInstance: FormInstance): Promise<AsyncJob> {
        const url = `${this.url}/${this.endpoint}/contentAsync/${formInstance.id}`;

        return this.http.put<AsyncJob>(url, formInstance)
            .toPromise()
            .then(response => {
                this.routeReuseService.setDoNotAttachHomePageOnNextNav();
                let obj = plainToClass(AsyncJob, response);

                return obj;
            })
            .catch(this.handleError);

    }

    public transitionAndSaveFormInstanceAsync(formInstance: FormInstance): Promise<AsyncJob> {
        const url = `${this.url}/${this.endpoint}/transitionAndSaveAsync/${formInstance.id}`;

        return this.http.put<AsyncJob>(url, formInstance)
            .toPromise()
            .then(response => {
                this.routeReuseService.setDoNotAttachHomePageOnNextNav();
                let obj = plainToClass(AsyncJob, response);

                return obj;
            })
            .catch(this.handleError);
    }

    public userLostAccessAfterTransition(jobKey: string): Promise<boolean> {
        const url = `${this.url}/${this.endpoint}/userLostAccessAfterTransition/${jobKey}`;
        return this.http.get<string>(url)
            .toPromise()
            .then(response => {
                return response == 'true';
            });
    }

    public getSavedFormInstance(jobKey: string): Promise<FormInstance> {
        const url = `${this.url}/${this.endpoint}/getSavedFormInstance/${jobKey}`;

        return this.http.get<FormInstance>(url)
            .toPromise()
            .then(response => {
                let obj: FormInstance = FormInstance.loadFromDeserializedNetworkData(response);
                return obj;
            })
            .catch(this.handleError);
    }
}
